// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"getStarted-module--wrapper--35mJV","button":"getStarted-module--button--LdD37"};